export const BASE_COLOR: Record<string, string> = {
	new: 'from-rose-300 to-rose-200',
	paid: 'from-lime-300 to-lime-200',
	dispatched: 'from-amber-300 to-amber-200',
	finished: 'from-zinc-300 to-zinc-200',
	cancelled: 'from-gray-200 to-gray-100',
}

export const BASE_BORDER: Record<string, string> = {
	new: 'border-rose-400 outline-rose-600',
	paid: 'border-lime-400 outline-lime-600',
	dispatched: 'border-amber-400 outline-amber-600',
	finished: 'border-zinc-400 outline-zinc-600',
	cancelled: 'border-gray-400 outline-gray-600',
}

export const ACTION_COLOR: Record<string, string> = {
	new: 'bg-rose-400',
	paid: 'bg-lime-400',
	dispatched: 'bg-amber-400',
	finished: 'bg-zinc-400',
	cancelled: 'bg-gray-400',
}

export const ROW_HEIGHT = 20
